

/// <reference path="StockNoteProductLine.ts" />

// Generated class DeliveryNoteLine_ManagedObject

class DeliveryNoteLine_ManagedObject extends StockNoteProductLine
{
}
